module.exports = __webpack_public_path__ + "img/total.1ebf1857.jpg";